<template>

<div>

    <v-dialog
    v-model="dialog_action_confirm"
    persistent
    scrollable
    max-width="600"
    >
        <v-card>
            <v-card-title>
                กรุณายืนยันที่จะปฏิเสธ {{ del_member['member_form_' + display_name_pos] }} ให้เป็นสมาชิก
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                text
                @click="dialog_action_confirm=false"
            >
                ยกเลิก
            </v-btn>
            <v-btn
                color="green darken-1"
                text
                @click="dialog_action_confirm=false;reject();"
            >
                ยืนยัน
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-row>
        <v-col cols="12" md="9">
            <v-text-field 
                v-model="search_field"
                prepend-icon="search"
                label="กรอกข้อมูลสมาชิกเพื่อค้นหา (เช่น ชื่อ, เบอร์โทร, เลขบัตรประชาชน)" hint="">
            </v-text-field>
        </v-col>
        <v-col cols="3" md="1" sm="2" class="flex"><v-btn color="primary" @click="reload">ค้นหา</v-btn></v-col>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="rows"
        :items-per-page="5"
        @click:row="onSelectMember"
        class="elevation-1"
    >
        <template v-slot:item.line_logo="{ item }">
            <img :src="item.line_logo" width="48" class="pt-1"/>
        </template>
        <template v-slot:item.member_date="{ item }">
            <div>{{ item.member_date.substring(0,10) + ' ' + item.member_date.substring(11,19) }}</div>
        </template>
        <template v-slot:item.action="{ item }">
            <v-btn class="ml-1" depressed color="primary" @click="onEditMember(item)">แก้ไข</v-btn>
            <v-btn class="ml-1" depressed color="error" @click="dialogReject(item)">ปฏิเสธ</v-btn>
            <v-btn class="ml-1" depressed color="success" @click="accept(item)">ยอมรับ</v-btn>
        </template>
    </v-data-table>

</div>
</template>


<script>

import config from '@/../config.js'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
    props: ['station_code'],
    data: () => ({
        headers: [
            { text:'',value:'line_logo'},
            {text: 'LINE', value: 'line_name'},
            {text: 'member_form_1', value: 'member_form_1',width:"11%"},
            {text: 'member_form_2', value: 'member_form_2',width:"11%"},
            {text: 'member_form_3', value: 'member_form_3',width:"11%"},
            {text: 'member_form_4', value: 'member_form_4',width:"11%"},
            {text: 'member_form_5', value: 'member_form_5',width:"11%"},
            {text: 'สมัครสมาชิกเมื่อ', value: 'datetime_created'},
            {text: '', value: 'action'},
        ],
        rows: [],
        registerformlist : [],
        search_text : null,
        search_field : "",

        display_name_pos : -1,

        dialog_action_confirm : false,
        del_member : {}
    }),
    methods: {
        onEditMember(member){
            this.$emit('oneditmember',member, true);
        },
        dialogReject(member){
            this.del_member = member
            this.dialog_action_confirm = true
        },
        reject(){
            var member = this.del_member
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.member.del_register
                ,{ 
                    station_code:this.station_code
                    ,member_id:member.member_id
                }
                ,{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.reload()
                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        accept(member){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.member.add_member
                ,{ 
                    station_code:this.station_code
                    ,link_by:3
                    ,link_val:member.member_id
                }
                ,{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.reload()
                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        reload(){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.public.station.get_registerform,{station_code:this.station_code})
            .then(response => {

                this.registerformlist = response.data.registerformlist

                for(var j=5;j>0;j--){
                    this.headers.forEach((v,i,arr)=>{
                        if(v.value=='member_form_'+j){
                            if(this.registerformlist.length>=j){
                                arr[i].text = this.$i18n.t('form_tag_'+this.registerformlist[j-1].form_tag)
                                if(this.registerformlist[j-1].form_tag=="name"){
                                    this.display_name_pos = j
                                }
                            }else{
                                arr.splice(i, 1);
                            }
                        }
                    })
                }
                axios.post(
                    this.search_field.length == 0 ?
                    config.api.url.manage.member.get_registerlist
                    : config.api.url.manage.member.search_registerlist
                ,{
                    station_code : this.station_code
                    ,fields : ["member_id","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5"]
                    ,seachtext:this.search_field
                },{ headers: Staff.getTokenHeader()})
                .then(response => {
                    this.rows = response.data.registerlist
                    this.rows.forEach((r,i,arr)=>{
                        if(r['member_form_'+this.display_name_pos] != undefined)
                            arr[i]["display_name"] = this.display_name_pos > -1 ? r['member_form_'+this.display_name_pos].split(',').join(' ') : r["line_name"]
                        for(var j=1;j<=5;j++){
                            if(this.headers.some(i=>i.value=='member_form_'+j)){
                                if(arr[i]['member_form_'+j] != undefined && arr[i]['member_form_'+j].length > 0){
                                    if(this.registerformlist[j-1].value_type_id==1){
                                        arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',').join(' ')
                                    }else if(this.registerformlist[j-1].value_type_id==2){
                                        arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',')[1]
                                    }
                                }
                            }
                        }
                        var d = new Date(r.datetime_created);
                        d.setHours(d.getHours()+7);
                        arr[i]['datetime_created'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);

                    })

                    this.$store.commit('finishLoading',que)
                })
            })
        }
    },
    mounted : function () {
        this.reload()
    } 
}
</script>